module.exports = __webpack_public_path__ + "static/media/4ODA19.afb8aff9.jpg";